import React from "react";

export function PrimaryActionButton(props) {
    return (
        <button
            className={`text-[1.6rem] min-w-[144px] px-12 py-6 font-semibold cursor-pointer text-white py-0 px-6 rounded-full border-none bg-primary-accent-normal hover:bg-primary-accent-hovered flex items-center justify-center ${
                props.className ? props.className : ""
            }`}
            onClick={props.onClick}
        >
            {props.label}
        </button>
    );
}
